
define('eteration/widgets/ui-keyboard-events',['jquery', 'knockout','eteration/ui/char-utils'],

function($,ko,charUtils) {
	
	
	ko.bindingHandlers['keyboard-input-filter'] = {

		init : function(element, valueAccessor, allBindings) {
			
			var keys = valueAccessor().allowed || [];
			var turkishtoLatin = valueAccessor().turkishtoLatin || false;
				var input = element,
			    oldValue,
			    newValue,
			    shiftKey,
			    altKey,
			    mask = false,
			    keyDownHandler = function(e) {
			    	oldValue = input.value;
			      	var code = charUtils.codeFromEvent(e);
		        	shiftKey = charUtils.shiftKeyFromEvent(e);
		        	altKey = charUtils.altKeyFromEvent(e);
		        	
		        	if(turkishtoLatin){
		        			var charEvent = e.key;
		        			var a = charEvent.turkishtoLatin();
		        	        code = a.charCodeAt(0);
	
		        	}

		        	if (code == 0 || code == 229) {
		        		mask=true;
		        		return false;
		    	    }
		        	var codeValid = charUtils.isCodeValid(code, shiftKey, altKey, charUtils.validators, keys);
		        	
		            if (!codeValid){
		            	e.preventDefault();
		            }
			    },
			    inputHandler = function(e) {
			    	newValue = input.value;
			    	if(mask){
			    		var codeValid = false;
			    		var i =0;
			    		do {
			    			codeValid = charUtils.isCodeValid(newValue[i].charCodeAt(0) || null, shiftKey, altKey, charUtils.validators, keys);
			    		    i++;
			    		} while ((i < newValue.length) && codeValid);
			    		
			    		if(codeValid){
			    			element.value = newValue;
			    		}else{
			    			element.value = oldValue;
			    		}
			    	}
			    	
			    };
			 input.addEventListener('input', inputHandler);
			 input.addEventListener('keydown', keyDownHandler);
	        
	        $(element).on('paste', function(event) {
	        	
	        	var allowPaste = false;
	        	var characters = '';
	        	if (typeof event.originalEvent.clipboardData !== 'undefined'){
	        		characters = event.originalEvent.clipboardData.getData('text/plain').trim();
	        	}else{
	        		characters = window.clipboardData.getData('Text').trim();
	        	}
	        	
	        	if (characters && characters.length) {
	        		
	        		allowPaste = true;
	        		
	        		for (var characterIndex = 0; characterIndex < characters.length; characterIndex++) {
						
	        			var code = characters.charCodeAt(characterIndex);
	    	        	var shiftKey = false;
	    	        	var altKey = false;
	    	        	
	    	        	var codeValid = charUtils.isCodeValid(code, shiftKey, altKey, charUtils.validators, keys);
						
	    	        	if(!codeValid){
	    	        		allowPaste = false;
	    	        	}
	    	        	
	        		}
	        		
				}
	        	
	        	if (!allowPaste) {
	        		event.preventDefault();
				}
	        	
			});
	        
	    }

	};
	





	ko.bindingHandlers['keyboard-paste-filter'] = {
			
		init : function(element, valueAccessor, allBindings) {
			
			$(element).on('copy paste cut', function(event) {
				event.preventDefault();
			});
	        
	    }

	};
	ko.bindingHandlers['keyboard-pnr-filter'] = {
			
			init : function(element, valueAccessor, allBindings) {
				
				$(element).on('input', function(event) {
					
				});
		        
		    },
		    update: function (element, valueAccessor, allBindingsAccessor)
		    {
		        var value = ko.utils.unwrapObservable(valueAccessor());
		       console.log(value)
		    }

		};
	ko.bindingHandlers['keyboard-enter'] = {
		    init: function (element, valueAccessor, allBindings, viewModel) {
		        var callback = valueAccessor();
		        $(element).keypress(function (event) {
		            var keyCode = (event.which ? event.which : event.keyCode);
		            if (keyCode === 13) {
		                callback.call(viewModel);
		                return false;
		            }
		            return true;
		        });
		    }
		};					
	
});





